import React, { useState } from "react";
import queryString from "query-string";
import Cookies from "js-cookie";
import utils from "../../../../../../utils";
import constants from "../../../../../../values/constants";
import values from "../../../../../../values";
import { SearchDropDownWithBase } from "../../../../../../components";
import { IOnSearchUser } from "../../../../../../types/common.interface";
import Context from "../../../../../../context";
import { useTranslation } from "react-i18next";

const Search = () => {
  const userType = utils.stringHexConversion.reverse(
    Cookies.get(constants.USER.TYPE)
  );

  // ============================ Value Validations =========================
  const { requestDebt, setRequestDebt } = React.useContext(Context.payAdminToDriverContext);
  const [defaultSearch, setDefaultSearch] = useState<string>(
    String(queryString.parse(window.location.search).search)?.split(":")[1]
  );
  const baseSearch = values.dropdownBaseSearch.TRANSACTION_BASE_SEARCH;

  // =============================== Navigation =============================

  function onSearch(event: IOnSearchUser) {
    setRequestDebt({
      ...requestDebt,
      search: {
        base: event?.base?.value,
        value: event?.searchedValue,
      },
    });
    return false;
  }

  const { t } = useTranslation();

  // ============================== JSX Contents ============================
  return (
    <SearchDropDownWithBase
      icon="fa-solid fa-magnifying-glass"
      defaultSearch={defaultSearch}
      size="medium-sd"
      onChangeSearch={(event: IOnSearchUser) => {
        onSearch(event);
        setDefaultSearch(event.searchedValue);
      }}
      defaultBaseSearch={baseSearch[0]}
      baseSearchItems={baseSearch.map((item) => ({
        ...item,
        title: t(item.title as string),
      }))}
    />
  );
};

export default Search;
